<div class="main global-table-wrapper">
    <div class="title-btn">
        <div class="main-title">
            <h1>Farm Users</h1>
            <p>Manage farm user access and permissions</p>
        </div>
        <div class="new-placement">
            <button class="btn btn-action-primary" routerLink="/add-farm-user">
                <i class="fas fa-plus"></i>
                New User
            </button>
        </div>
    </div>

    <p-table [value]="data" responsiveLayout="scroll" [loading]="loading">
        <ng-template pTemplate="header">
            <tr>
                <th>Employee ID</th>
                <th>Username</th>
                <th>Role</th>
                <th>Phone</th>
                <th>Created On</th>
                <th>Email</th>
                <th></th>
                <th></th>
                <th></th>
                <th></th>
            </tr>
        </ng-template>
        <ng-template pTemplate="body" let-item>
            <tr>
                <td>{{ item.employeeId }}</td>
                <td>{{ item.name }}</td>
                <td>
                    <span class="role-badge">{{ item.roleName }}</span>
                </td>
                <td>{{ item.phone || 'N/A' }}</td>
                <td>{{ item.createdOn | date: 'MMM dd, yyyy' }}</td>
                <td>{{ item.email || 'No email' }}</td>
                <td>
                    <a
                        (click)="viewUserDetails(item)"
                        pTooltip="View Details"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-eye"></i
                    ></a>
                </td>
                <!-- <td>
                    <a
                        pTooltip="User Permission"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-user-shield"></i
                    ></a>
                </td> -->
                <td>
                    <a
                        (click)="editUser(item)"
                        pTooltip="Edit Profile"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-edit"></i
                    ></a>
                </td>
                <td>
                    <a
                        (click)="deleteUser(item)"
                        pTooltip="Delete User"
                        tooltipPosition="top"
                        class="table-action-icon"
                        ><i class="fas fa-trash"></i
                    ></a>
                </td>
            </tr>
        </ng-template>
    </p-table>

    <p-paginator
        *ngIf="!loading && data.length > 0"
        [rows]="pageSize"
        [totalRecords]="totalRecords"
        [first]="(currentPage - 1) * pageSize"
        (onPageChange)="onPageChange($event)"
        [showFirstLastIcon]="false"
        styleClass="custom-paginator"
    ></p-paginator>

    <!-- Empty State -->
    <div *ngIf="!loading && data.length === 0" class="smart-table-empty-state">
        <div class="empty-icon">
            <i class="fas fa-users"></i>
        </div>
        <h3 class="empty-title">No farm users found</h3>
        <p class="empty-message">
            <span *ngIf="name">No users match your search criteria.</span>
            <span *ngIf="!name"
                >Get started by adding your first farm user.</span
            >
        </p>
        <button
            *ngIf="!name"
            class="empty-action-btn"
            routerLink="/main/add-farm-user"
        >
            <i class="fas fa-plus"></i>
            Add First User
        </button>
    </div>

    <!-- Loading State -->
    <div *ngIf="loading" class="smart-table-loading-state">
        <div class="loading-spinner">
            <i class="fas fa-spinner fa-spin"></i>
        </div>
        <p class="loading-text">Loading farm users...</p>
    </div>
</div>

<!-- User Details Modal -->
<p-dialog
    [(visible)]="displayUserDialog"
    modal="true"
    focusOnShow="false"
    [style]="{width: '900px'}"
    [closable]="false"
    [baseZIndex]="200000"
    [appendTo]="'body'"
>
    <div class="text-left close-popup-pdialog" (click)="closeDialog()">
        <span class="fas fa-chevron-left"></span> Back
    </div>
    <ng-template pTemplate="content">
        <app-view-farm-user
            [userDetails]="selectedUser"
            (closeDialog)="closeDialog()"
        ></app-view-farm-user>
    </ng-template>
</p-dialog>

<p-dialog
    [(visible)]="displayDeleteDialog"
    modal="true"
    [closable]="true"
    [style]="{width: '400px'}"
    [responsive]="true"
>
    <p class="text-center">Are you sure you want to delete this user?</p>
    <div class="text-center">
        <button (click)="deleteItem()" class="btn btn-danger mr-1">
            Delete
        </button>
        <button (click)="displayDeleteDialog = false" class="btn btn-secondary">
            Cancel
        </button>
    </div>
</p-dialog>
